import React, { FC } from "react";
import { NavbarWidget } from "shared/components/__FOX__/NAV/src";
import { useTheme } from "styled-components";
import { useGetFilteredTabs } from "../components/navigationSystem/useGetFilteredTabs";

const SectionCGrave: FC = () => {
    const theme = useTheme();

    const items = useGetFilteredTabs()

    return (
        <NavbarWidget.Links
            key="links-widget"
            theming={{ ...theme.navigationBar.links, hoverColor: "#ff00ff", activeColor: "#ff00ff" }}
            items={items}
        />
    );
};

export default SectionCGrave;
import React, { FC } from "react";
import { NavbarWidget } from "shared/components/__FOX__/NAV/src";
import { useTheme } from "styled-components";
import { useGetFilteredTabs } from "../components/navigationSystem/useGetFilteredTabs";

const SectionCGrave: FC = () => {
    const theme = useTheme();

    const items = useGetFilteredTabs()

    return (
        <NavbarWidget.Links
            key="links-widget"
            theming={{ ...theme.navigationBar.links, hoverColor: "#ff00ff", activeColor: "#ff00ff" }}
            items={items}
        />
    );
};

export default SectionCGrave;
